import { useQuery } from '@tanstack/react-query';
import { ccrcTypeAApi, ccrcTypeAKeys } from '@/api/waterlily';

export function useCcrcTypeAProducts() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ccrcTypeAKeys.all,
    queryFn: () => ccrcTypeAApi.getProducts(),
  });

  return {
    products: data?.products ?? [],
    isLoading,
    isError,
  };
}
